import React from "react";
import { PanelBody } from "../panel/panel.jsx";
import ModalContainer from "../ModalContainer.tsx";
import PlantillaModalPuestos from "./PlantillaModalPuestos.tsx";
import { useSelector } from "react-redux";
import { RootState } from "../../store/index.ts";

const PlantillaFormPuestos = ({ formik, error }) => {
  const [showModal, setShowModal] = React.useState(false);
  const [currentRecord, setCurrentRecord] = React.useState(null);
  const { positionsOriginal } = useSelector(
    (state: RootState) => state.branchTemplates
  );
  const [selectedPositions, setSelectedPositions] = React.useState<number[]>(
    []
  );

  const filteredPuestosWithIndex = React.useMemo(() => {
    return formik.values.puestos
      .map((doc, realIndex) => ({ doc, realIndex }))
      .filter(({ doc }) => {
        const position = positionsOriginal.find(
          (position) => position.id === doc.puesto || position.id === doc.id
        );
        return position && !position.isDelete;
      });
  }, [formik.values.puestos, positionsOriginal]);

  const handleCheckboxChange = (realIndex: number) => {
    setSelectedPositions((prevSelected: number[]) => {
      if (prevSelected.includes(realIndex)) {
        return prevSelected.filter((i) => i !== realIndex);
      } else {
        return [...prevSelected, realIndex];
      }
    });
  };

  const handleDeleteSelected = () => {
    const newPuestos = formik.values.puestos.filter(
      (_, i) => !selectedPositions.includes(i)
    );
    formik.setFieldValue("puestos", newPuestos);
    setSelectedPositions([]);
  };

  const addAllPositions = () => {
    const newPuestos = positionsOriginal.map((position) => {
      return {
        puesto: position.id,
        matutino: 1,
        intermedio: 1,
        vespertino: 1,
        showSchedule: true,
        isHire: true,
        isEssencial: false,
      };
    });

    formik.setFieldValue("puestos", newPuestos);
  };

  return (
    <div>
      <PanelBody>
        <div style={{ display: "flex", flexDirection: "row", marginTop: "1%" }}>
          <div className="col-md-1" />
          <div className="col-md-10">
            <button
              type="button"
              className={`btn btn-outline-${error ? "danger" : "secondary"}`}
              onClick={() => setShowModal(true)}
            >
              <i className="fas fa-plus"></i> Agregar puesto
            </button>
            <button
              type="button"
              className={`btn btn-outline-secondary ms-3`}
              onClick={() => addAllPositions()}
            >
              <i className="fas fa-plus"></i> Agregar a todos los puestos
              disponibles
            </button>
            {error && (
              <div className="text-danger mt-1" role="alert">
                {error}
              </div>
            )}

            <div
              style={{
                border: "1px solid #e0e0e0",
                borderRadius: "8px",
                overflow: "hidden",
                backgroundColor: "#fff",
                marginTop: "16px",
              }}
            >
              {filteredPuestosWithIndex.length === 0 ? (
                <div
                  style={{
                    padding: "40px",
                    textAlign: "center",
                    color: "#999",
                  }}
                >
                  <i
                    className="fa fa-inbox"
                    style={{
                      fontSize: "48px",
                      marginBottom: "16px",
                      display: "block",
                    }}
                  ></i>
                  <p style={{ margin: 0, fontSize: "16px" }}>
                    No hay puestos agregados
                  </p>
                </div>
              ) : (
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead>
                    <tr
                      style={{
                        backgroundColor: "#f8f9fa",
                        borderBottom: "2px solid #e0e0e0",
                      }}
                    >
                      <th
                        style={{
                          padding: "12px 16px",
                          textAlign: "left",
                          width: "40px",
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={
                            filteredPuestosWithIndex.length > 0 &&
                            selectedPositions.length ===
                              filteredPuestosWithIndex.length
                          }
                          onChange={(e) => {
                            if (e.target.checked) {
                              setSelectedPositions(
                                filteredPuestosWithIndex.map(
                                  ({ realIndex }) => realIndex
                                )
                              );
                            } else {
                              setSelectedPositions([]);
                            }
                          }}
                          style={{
                            cursor: "pointer",
                            width: "18px",
                            height: "18px",
                            accentColor: "#007bff",
                          }}
                        />
                      </th>
                      <th
                        style={{
                          padding: "12px 16px",
                          textAlign: "left",
                          fontSize: "12px",
                          fontWeight: "600",
                          color: "#666",
                          textTransform: "uppercase",
                        }}
                      >
                        Puesto
                      </th>
                      <th
                        style={{
                          padding: "12px 16px",
                          textAlign: "center",
                          fontSize: "12px",
                          fontWeight: "600",
                          color: "#666",
                          textTransform: "uppercase",
                        }}
                      >
                        Matutino
                      </th>
                      <th
                        style={{
                          padding: "12px 16px",
                          textAlign: "center",
                          fontSize: "12px",
                          fontWeight: "600",
                          color: "#666",
                          textTransform: "uppercase",
                        }}
                      >
                        Intermedio
                      </th>
                      <th
                        style={{
                          padding: "12px 16px",
                          textAlign: "center",
                          fontSize: "12px",
                          fontWeight: "600",
                          color: "#666",
                          textTransform: "uppercase",
                        }}
                      >
                        Vespertino
                      </th>
                      <th
                        style={{
                          padding: "12px 16px",
                          textAlign: "center",
                          fontSize: "12px",
                          fontWeight: "600",
                          color: "#666",
                          textTransform: "uppercase",
                        }}
                      >
                        Horario
                      </th>
                      <th
                        style={{
                          padding: "12px 16px",
                          textAlign: "center",
                          fontSize: "12px",
                          fontWeight: "600",
                          color: "#666",
                          textTransform: "uppercase",
                        }}
                      >
                        Contratable
                      </th>
                      <th
                        style={{
                          padding: "12px 16px",
                          textAlign: "center",
                          fontSize: "12px",
                          fontWeight: "600",
                          color: "#666",
                          textTransform: "uppercase",
                        }}
                      >
                        Esencial
                      </th>
                      <th
                        style={{
                          padding: "12px 16px",
                          textAlign: "center",
                          fontSize: "12px",
                          fontWeight: "600",
                          color: "#666",
                          textTransform: "uppercase",
                          width: "60px",
                        }}
                      >
                        Acción
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredPuestosWithIndex.map(
                      ({ doc, realIndex }, index, array) => (
                        <tr
                          key={realIndex}
                          style={{
                            borderBottom:
                              index < array.length - 1
                                ? "1px solid #f0f0f0"
                                : "none",
                            transition: "background-color 0.2s ease",
                            backgroundColor: "#fff",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = "#f8f9fa";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = "#fff";
                          }}
                        >
                          <td
                            style={{
                              padding: "12px 16px",
                              textAlign: "center",
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={selectedPositions.includes(realIndex)}
                              onChange={() => handleCheckboxChange(realIndex)}
                              style={{
                                cursor: "pointer",
                                width: "18px",
                                height: "18px",
                                accentColor: "#007bff",
                              }}
                            />
                          </td>
                          <td
                            style={{
                              padding: "12px 16px",
                              fontSize: "14px",
                              fontWeight: "500",
                              color: "#333",
                            }}
                          >
                            {positionsOriginal.find(
                              (position) =>
                                position.id === doc.puesto ||
                                position.id === doc.id
                            )?.name || "Sin nombre"}
                          </td>
                          <td
                            style={{
                              padding: "12px 16px",
                              textAlign: "center",
                              fontSize: "14px",
                              color: "#555",
                            }}
                          >
                            {doc.matutino || 0}
                          </td>
                          <td
                            style={{
                              padding: "12px 16px",
                              textAlign: "center",
                              fontSize: "14px",
                              color: "#555",
                            }}
                          >
                            {doc.intermedio || 0}
                          </td>
                          <td
                            style={{
                              padding: "12px 16px",
                              textAlign: "center",
                              fontSize: "14px",
                              color: "#555",
                            }}
                          >
                            {doc.vespertino || 0}
                          </td>
                          <td
                            style={{
                              padding: "12px 16px",
                              textAlign: "center",
                            }}
                          >
                            <i
                              className={`fa ${
                                doc.showSchedule ?? true
                                  ? "fa-check-circle text-success"
                                  : "fa-times-circle text-danger"
                              }`}
                              style={{ fontSize: "20px" }}
                              title={
                                doc.showSchedule ?? true
                                  ? "Mostrar en horario"
                                  : "No mostrar en horario"
                              }
                            ></i>
                          </td>
                          <td
                            style={{
                              padding: "12px 16px",
                              textAlign: "center",
                            }}
                          >
                            <i
                              className={`fa ${
                                doc.isHire ?? true
                                  ? "fa-check-circle text-success"
                                  : "fa-times-circle text-danger"
                              }`}
                              style={{ fontSize: "20px" }}
                              title={
                                doc.isHire ?? true
                                  ? "Contratable"
                                  : "No contratable"
                              }
                            ></i>
                          </td>
                          <td
                            style={{
                              padding: "12px 16px",
                              textAlign: "center",
                            }}
                          >
                            <i
                              className={`fa ${
                                doc.isEssencial ?? true
                                  ? "fa-check-circle text-success"
                                  : "fa-times-circle text-danger"
                              }`}
                              style={{ fontSize: "20px" }}
                              title={
                                doc.isEssencial ?? true
                                  ? "Esencial"
                                  : "No esencial"
                              }
                            ></i>
                          </td>
                          <td
                            style={{
                              padding: "12px 16px",
                              textAlign: "center",
                            }}
                          >
                            <a
                              href="#/"
                              onClick={(e) => {
                                e.preventDefault();
                                setCurrentRecord(doc);
                                setShowModal(true);
                              }}
                              style={{
                                color: "#007bff",
                                textDecoration: "none",
                                padding: "6px 8px",
                                borderRadius: "4px",
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                transition: "background-color 0.2s ease",
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor =
                                  "#e7f3ff";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor =
                                  "transparent";
                              }}
                              title="Editar puesto"
                            >
                              <i
                                className="fa fa-pen"
                                style={{ fontSize: "16px", cursor: "pointer" }}
                              ></i>
                            </a>
                          </td>
                        </tr>
                      )
                    )}
                  </tbody>
                </table>
              )}
            </div>
            {selectedPositions.length > 0 && (
              <button
                type="button"
                className="btn btn-danger mt-3"
                onClick={handleDeleteSelected}
              >
                <i className="fa fa-trash  text-white"></i>
                <span className="ms-2 text-white"> Eliminar seleccionados</span>
              </button>
            )}
          </div>
        </div>
      </PanelBody>
      <ModalContainer
        open={showModal}
        closeFn={() => {
          setShowModal(false);
          setCurrentRecord(null);
        }}
        title={currentRecord ? "Editar puesto" : "Agregar puesto"}
        children={
          <PlantillaModalPuestos
            fomik={formik}
            closeFn={() => {
              setShowModal(false);
              setCurrentRecord(null);
            }}
            currentRecord={currentRecord}
          />
        }
      />
    </div>
  );
};

export default PlantillaFormPuestos;
